/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface EnqueueAcceptedBidsForSixbidSync$Params {
  auctionId: number;
  'X-API-Version'?: string;
}

export function enqueueAcceptedBidsForSixbidSync(http: HttpClient, rootUrl: string, params: EnqueueAcceptedBidsForSixbidSync$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, enqueueAcceptedBidsForSixbidSync.PATH, 'get');
  if (params) {
    rb.path('auctionId', params.auctionId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

enqueueAcceptedBidsForSixbidSync.PATH = '/api/admin/enqueueacceptedBidIds/{auctionId}';
